import React, { useEffect, useState } from 'react'
import { ExhibitStatus } from '@prisma/client'
import { ExhibitionWithWorks } from '@src/lib/apiClient'
import { CaretForward, CaretDown } from 'react-ionicons'
import { ExhibitionListItem } from './ExhibitionListItem'
import { SortableList } from './SortableList'
import { WorkListItem } from './WorkListItem'
import { logger } from '../lib/logger'

interface Props {
  e: ExhibitionWithWorks;
  onExhibitionWithWorksChange: (update: ExhibitionWithWorks['works']) => Promise<void>;
}

export default function ExhibitionWithSortableWorks({ e, onExhibitionWithWorksChange } : Props) {
  const [worksVisible, setWorksVisible] = useState<boolean>(ExhibitStatus[e.showStatus] !== ExhibitStatus[ExhibitStatus.Archived]) // Need to use this weird syntax to make typescript recognize equality of 2 enums...
  useEffect(() => {
    setWorksVisible(ExhibitStatus[e.showStatus] !== ExhibitStatus[ExhibitStatus.Archived])
  }, [e])

  return (
    <>
      <div className="flex">
        <ExhibitionListItem key={e.id} exhibition={e} showEditLink />
        <button type="button" className="caretBtn" onClick={() => { setWorksVisible(!worksVisible) }} onKeyDown={() => { logger.info('Show/Hide Exhibition Works') }}>
          {worksVisible ? (
            <CaretDown />
          ) : (
            <CaretForward />
          )}
        </button>
      </div>
      <div className={`${worksVisible ? '' : 'hidden'}`}>
        <SortableList
          items={e.works}
          onChange={onExhibitionWithWorksChange}
          renderItem={(item) => (
            <SortableList.Item id={item.id}>
              <SortableList.DragHandle />
              <WorkListItem adminView settingsLink work={item} />
            </SortableList.Item>
          )}
        />
      </div>
    </>
  )
}
